import React from 'react';
import { DeviceType } from '@wix/cashier-common/dist/src/enums/DeviceType';
import cn from 'classnames';
import { DH } from '../../utils/DataHook';
import { AddPaymentMethodButton } from '../AddPaymentMethodButton';
import { CardsListDesktop } from './Desktop';
import { CardsListMobile } from './Mobile';
import { RemovalErrorMessage, MarkCardPrimaryErrorMessage, CardAddedMessage } from './elements';
import { ICardsListConnectedProps } from './view.connect';
import s from './styles.scss';

export class CardsList extends React.Component<ICardsListConnectedProps> {
  render() {
    const isMobile = this.props.deviceType === DeviceType.Mobile;
    const CardsListComponent: React.FC<any> = isMobile ? CardsListMobile : CardsListDesktop;

    const showAddPaymentMethodButton = this.props.canAddPaymentMethod && (isMobile ? !this.props.expandedCardId : true);

    return (
      <section data-hook={DH.CardsListContainer} className={s.cardsListContainer}>
        <CardsListComponent {...this.props} />
        {this.props.isMarkCardPrimaryFailed && (
          <MarkCardPrimaryErrorMessage onClose={this.props.closeFailedMarkPrimaryErrorMessage} />
        )}
        {this.props.isRemovingFailed && <RemovalErrorMessage onClose={this.props.closeFailedDeleteCardMessage} />}
        {this.props.showCardAddedMessage && <CardAddedMessage onClose={this.props.hideCardAddedMessage} />}
        {showAddPaymentMethodButton && (
          <div className={cn(s.addPaymentMethodButtonWrapper, { [s.mobile]: isMobile })}>
            <AddPaymentMethodButton />
          </div>
        )}
      </section>
    );
  }
}
